webpackJsonpCfHeader([4],{

/***/ 76:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function __export(m) {
	    for (var p in m) {
	        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	    }
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(97));

/***/ },

/***/ 97:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(16);
	var styles = __webpack_require__(124);
	exports.Approval = function (_ref) {
	  var message = _ref.message;
	
	  return _jsx("div", {
	    className: styles['container']
	  }, void 0, _jsx("div", {
	    className: styles['icon']
	  }), _jsx("div", {
	    className: styles['content']
	  }, void 0, message));
	};

/***/ },

/***/ 124:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2Fmd4ZDqJu7rPlxO","icon":"_31AJtVgg0IQYd_pg"};

/***/ }

});


// WEBPACK FOOTER //
// header-bf75671daa3dce50f485.js